import styled from 'styled-components';

import {
  Page, NormalSection, HighlightSection,
  Header, Title, BottomTag,
  Content, ContentTag, TextGroup, DropBorder, DropBox
} from './components';

import jetTakeoff from './images/jet-takeoff.jpeg';
import meeting from './images/meeting.jpg';
import mainDesk from './images/home-desk.jpeg';

const TopTitle = styled(Title)`
  max-width: 580px;

  @media(max-width: 800px) {
    max-width: 260px;
    font-size: 1.8em;
  }
`;

const TopContent = styled(Content)`
  display: flex;

  img {
    margin-left: 20px;
    height: 560px;
    width: 260px;
    object-fit: cover;
  }

  @media(max-width: 1000px) {
    flex-direction: column;

    img {
      margin-top: 20px;
      margin-left: 0;
      width: 100%;
      height: 300px;
    }
  }
`;

const HomeHighlightSection = styled(HighlightSection)`
  padding-bottom: 0px;
  padding-top: 0px;
`;

const HighlightHeader = styled(Header)`
  padding-right: 140px;
`;

const HighlightContent = styled(Content)`
  display: flex;

  img {
    margin-right: 20px;
    height: 600px;
    width: 300px;
    object-fit: cover;
    margin-bottom: 0px;
  }

  @media(max-width: 1000px) {
    flex-direction: column;

    img {
      display: none;
    }
  }
`;

const MainHeader = styled(Header)`
  background-image: url(${mainDesk});
  background-repeat: no-repeat;
  background-size: 1460px auto;
  padding-top: 60px;
  padding-right: 20px;
  min-height: 670px;
  font-size: 1.3em;
  margin-bottom: 0px;
`;

const Philosophy = styled.div`
  background-color: #a0a0a060;
  margin-left: auto;
  margin-right: 200px;
  width: 360px;
  padding: 20px;
  border-radius: 12px;

  @media(max-width: 1200px) {
    display: none;
  }
`;

const PhilosophyTitle = styled.div`
  text-transform: uppercase;
  margin-bottom: 6px;
`;

const PhilosophySubtitle = styled.div`
  font-size: 1.4em;
  font-weight: 600;
`;

const PhilosophyBody = styled.p`
  margin-bottom: 10px;
`;

const PhilosophyButton = styled.div`
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  width: 160px;
  text-align: center;
  border-width: 3px;
  border-color: black;
  border-style: solid;
  border-radius: 12px;
  cursor: pointer;
`;

const Home = ({ scrollToContact }) => {
  return (
    <Page>
      <NormalSection>
        <MainHeader>
          <TopTitle>
            Custom Software for<br />Your Unique Business Challenges
          </TopTitle>
          <Philosophy>
            <PhilosophyTitle>Our Philosophy</PhilosophyTitle>
            <PhilosophySubtitle>Love the Journey</PhilosophySubtitle>
            <PhilosophyBody>
              At Preflight, we don't want you to get bogged down in the
              minutiae of the day to day. We are commmitted to creating
              unique software for your business so you can get back to
              LOVING THE JOURNEY
            </PhilosophyBody>
            <PhilosophyBody style={{textAlign: 'center'}}>
              Get your free Discovery call today
            </PhilosophyBody>
            <PhilosophyButton onClick={scrollToContact}>
              Schedule Now
            </PhilosophyButton>
          </Philosophy>
        </MainHeader>
        <TopContent>
          <div>
            <Content style={{marginTop: 0}}>
              <ContentTag style={{marginTop: -10}}>
                Get Off the Runway
              </ContentTag>
              <TextGroup>
                <DropBorder />
                <p>
                  Are you an established business trying to fly with less
                  turbulence or a brand new company just trying to get off
                  the ground? Preflight Technologies is here to help.
                </p>
                <p>
                  We are a team of developers, architects, and project
                  managers with experience and a singular focus. Using our
                  experience and consideration, we create a custom look
                  and functionality for your software to lift your business
                  technology into the skies of success.
                </p>
              </TextGroup>
            </Content>
            <Content>
              <ContentTag>
                You Need a Reliable Co-Pilot
              </ContentTag>
              <TextGroup>
                <DropBorder />
                <p>
                  At Preflight Technologies, we pride ourselves on looking at
                  your business as if it were ours. By getting into this co-pilot
                  mindset, we’re not only more efficient on your projects... we’re
                  hyper-focused on them.
                </p>
              </TextGroup>
            </Content>
          </div>
          <img src={jetTakeoff} alt="Jet Taking Off" />
        </TopContent>
      </NormalSection>
      <HomeHighlightSection className="dark-highlight">
        <HighlightContent>
          <img src={meeting} alt="Meeting" />
          <div>
            <HighlightHeader>
              <Title>Helping Your Business Love the Journey</Title>
              <BottomTag>Mapping a Clear Path to Your Destination</BottomTag>
            </HighlightHeader>
            <Content className="dark-highlight-padded">
              <div style={{position: 'relative'}}>
                <TextGroup>
                  <DropBorder />
                  <p>
                    Our US-based team is dedicated to meeting your company’s
                    actual needs.
                    We do so by looking at three key areas of concern: your
                    immediate concerns, your long-term planning, and your
                    future growth.
                  </p>
                  <p>
                    We understand that achieving success means focusing on the
                    here and now while looking ahead for potential issues. When you
                    work with us, we’ll take care of your immediate needs, create a
                    long-term plan to prevent issues from reappearing later on, and
                    include steps to support your future growth.
                  </p>
                </TextGroup>
                <DropBox />
              </div>
            </Content>
          </div>
        </HighlightContent>
      </HomeHighlightSection>
    </Page>
  );
};

export default Home;
